import { scan } from "react-scan";
import {StrictMode} from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { Provider } from "@/components/chakra-ui-snippets/provider.tsx";
import { GoogleOAuthProvider,} from "@react-oauth/google";
import App from "@/components/App.tsx";

scan({
  enabled: false,
});

createRoot(document.getElementById("root")!).render(
      <StrictMode>
        <Provider>
            <GoogleOAuthProvider clientId="472994848443-s7ijqog7mvae1lpib52bfv4lb1v9jjd6.apps.googleusercontent.com">
                
                <App />
            </GoogleOAuthProvider>
        </Provider>
      </StrictMode>
);
